import { logger } from '../../core/logger';
import { isPaymentOutputEvent, paymentOutputEvent } from '../../types/external/payment-output-event';

export type EventListenerStore = Record<string, Array<(data: unknown) => void>>;

export const createEventStore = (): EventListenerStore => ({});

/**
 * Adds an event listener to the store
 */
export const addEventListenerToStore = (
  store: EventListenerStore,
  eventName: string,
  callback: (data: unknown) => void
): EventListenerStore => {
  const updatedStore = { ...store };
  if (!updatedStore[eventName]) {
    updatedStore[eventName] = [];
  }
  updatedStore[eventName] = [...updatedStore[eventName], callback];
  return updatedStore;
};

/**
 * Validates and adds a payment output event listener
 */
export const addValidatedEventListener = (
  store: EventListenerStore,
  eventName: unknown,
  callback: (data: unknown) => void
): { store: EventListenerStore; valid: boolean } => {
  if (!eventName || !callback) {
    logger.error('Event name and callback are required');
    return { store, valid: false };
  }

  if (typeof callback !== 'function') {
    logger.error('Callback must be a function');
    return { store, valid: false };
  }

  if (!isPaymentOutputEvent(eventName)) {
    logger.error(`Invalid event name. Valid events are: ${paymentOutputEvent.join(', ')}`);
    return { store, valid: false };
  }

  return {
    store: addEventListenerToStore(store, eventName, callback),
    valid: true
  };
};

/**
 * Triggers event listeners in the store
 */
export const triggerEvent = (store: EventListenerStore, eventName: string, data: unknown): void => {
  const listeners = store[eventName] || [];

  listeners.forEach((callback) => {
    try {
      callback(data);
    } catch (error) {
      logger.error(`Error in ${eventName} event listener:`, error);
    }
  });
};
